import _ from 'lodash';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { showErrors } from '../../modules/general';
import { apiFetch, apiSearch } from '../../modules/utility';
const apiBase = 'interstateBol';

const mapStateToProps = (state, ownProps) => {
	let interstateBols;
	let interstateBol;
	let interstateBolId;

	if (state.lists.interstateBolIds) {
		interstateBols = _.map(state.lists.interstateBolIds, (id) => state.maps.interstateBol[id]);
	}

	if (ownProps.interstateBol) {
		interstateBol = ownProps.interstateBol;
	} else {
		interstateBolId = ownProps.interstateBolId
			? ownProps.interstateBolId
			: _.get(ownProps, ['match', 'params', 'interstateBolId']);
		interstateBol = _.get(state.maps, ['interstateBol', interstateBolId]);
	}

	return {
		interstateBol,
		interstateBols,
		authUser: state.auth.authUser,
		userMap: state.maps.user,
		resourceMap: state.maps.resource,
		stationDeliveryMap: state.maps.stationDelivery,
		stationMap: state.maps.station,
		terminalMap: state.maps.terminal,
	};
};

const search = (p = {}) => {
	const { afterDateTime, bolNumber, callback = _.noop } = p;
	return (dispatch) => {
		apiSearch({
			base: apiBase,
			params: {
				afterDateTime,
				bolNumber,
			},
			dispatch,
			callback,
		});
	};
};

const uploadBol = ({ params, callback = _.noop }) => {
	return (dispatch) => {
		apiFetch({
			method: `${apiBase}.uploadBol`,
			params,
			dispatch,
			callback,
		});
	};
};

const reparseBol = ({ params, callback = _.noop }) => {
	return (dispatch) => {
		apiFetch({
			method: `${apiBase}.reparse`,
			params,
			dispatch,
			callback,
		});
	};
};

const mapDispatchToProps = (dispatch) =>
	bindActionCreators(
		{
			interstateBolSearch: search,
			interstateBolUpload: uploadBol,
			interstateBolReparse: reparseBol,
			showErrors,
		},
		dispatch
	);

export default connect(mapStateToProps, mapDispatchToProps);
